import { message } from 'antd'
import { fetchUtil as fetch } from 'src/utils/fetch'

export const fetchNotifications = async (page, size, botUserId) => {
  const { data } = await fetch(
    `/notifications/${botUserId}?&page=${page}&size=${size}`,
    {
      headers: {
        role: 'ADMIN',
      },
    }
  )
  return data
}

export const unreadCountNotification = async (botUserId) => {
  const { data } = await fetch(`/notifications/unread/${botUserId}`, {
    headers: {
      role: 'ADMIN',
    },
  })
  return data
}
